(function () {
  if (window.__kayoniMotion) return;
  window.__kayoniMotion = true;

  var rm = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var design = window.Shopify && window.Shopify.designMode;
  var skip = /__(hero_main|kayoni_motion|kayoni_trust)$/;

  function inView(el) {
    var r = el.getBoundingClientRect();
    return r.top < window.innerHeight && r.bottom > 0;
  }

  function reveal() {
    if (rm || design || !('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('k-in'); io.unobserve(e.target); }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });

    var targets = [];
    document.querySelectorAll('#MainContent > .shopify-section').forEach(function (s) {
      if (!skip.test(s.id)) targets.push(s);
    });
    document.querySelectorAll('#MainContent > .shopify-section').forEach(function (s) {
      s.querySelectorAll('product-card, .k-card').forEach(function (el, i) {
        el.style.setProperty('--k-delay', (i % 4) * 110 + 'ms');
        targets.push(el);
      });
    });
    targets.forEach(function (el) {
      if (el.classList.contains('k-reveal') || inView(el)) return;
      el.classList.add('k-reveal');
      io.observe(el);
    });
  }

  function makePetals(box, n, minD, maxD, minO, maxO) {
    for (var i = 0; i < n; i++) {
      var p = document.createElement('span');
      p.className = 'k-petal';
      p.style.setProperty('--s', (10 + Math.random() * 16).toFixed(1) + 'px');
      p.style.setProperty('--x', (Math.random() * 100).toFixed(1) + '%');
      p.style.setProperty('--d', (minD + Math.random() * (maxD - minD)).toFixed(1) + 's');
      p.style.setProperty('--dl', (-Math.random() * maxD).toFixed(1) + 's');
      p.style.setProperty('--o', (minO + Math.random() * (maxO - minO)).toFixed(2));
      box.appendChild(p);
    }
  }

  function petals() {
    if (rm || document.querySelector('.k-petals--page')) return;
    var isHome = !!document.querySelector('#MainContent > .shopify-section[id$="__hero_main"]');
    var mobile = window.innerWidth < 750;
    var page = document.createElement('div');
    page.className = 'k-petals k-petals--page';
    page.setAttribute('aria-hidden', 'true');
    if (isHome) makePetals(page, mobile ? 9 : 16, 12, 22, 0.4, 0.8);
    else makePetals(page, mobile ? 5 : 9, 14, 26, 0.3, 0.6);
    document.body.appendChild(page);
  }

  function carousels() {
    document.querySelectorAll('[data-k-carousel]').forEach(function (c) {
      if (c.dataset.kReady) return;
      c.dataset.kReady = '1';
      var track = c.querySelector('.k-reviews__track');
      if (!track) return;
      var slides = [].slice.call(track.children);
      var dotsWrap = c.querySelector('.k-dots');
      var dots = [];
      var paused = false, t2 = null;

      function cur() {
        var x = track.scrollLeft, best = 0, bd = Infinity, base = slides[0] ? slides[0].offsetLeft : 0;
        slides.forEach(function (s, i) {
          var d = Math.abs(s.offsetLeft - base - x);
          if (d < bd) { bd = d; best = i; }
        });
        return best;
      }
      function atEnd() { return track.scrollLeft + track.clientWidth >= track.scrollWidth - 6; }
      function go(i) {
        if (!slides.length) return;
        i = (i + slides.length) % slides.length;
        track.scrollTo({ left: slides[i].offsetLeft - slides[0].offsetLeft, behavior: rm ? 'auto' : 'smooth' });
      }
      function update() {
        var i = cur();
        dots.forEach(function (d, j) { d.classList.toggle('is-active', j === i); });
      }

      if (dotsWrap) {
        slides.forEach(function (_, i) {
          var b = document.createElement('button');
          b.type = 'button';
          b.className = 'k-dot';
          b.setAttribute('aria-label', 'Go to review ' + (i + 1));
          b.addEventListener('click', function () { go(i); });
          dotsWrap.appendChild(b);
          dots.push(b);
        });
      }
      var prev = c.querySelector('[data-k-prev]'), next = c.querySelector('[data-k-next]');
      if (prev) prev.addEventListener('click', function () { go(cur() - 1); });
      if (next) next.addEventListener('click', function () { atEnd() ? go(0) : go(cur() + 1); });
      track.addEventListener('scroll', function () { clearTimeout(t2); t2 = setTimeout(update, 80); }, { passive: true });

      ['mouseenter', 'touchstart', 'focusin'].forEach(function (ev) { c.addEventListener(ev, function () { paused = true; }, { passive: true }); });
      ['mouseleave', 'focusout'].forEach(function (ev) { c.addEventListener(ev, function () { paused = false; }); });
      c.addEventListener('touchend', function () { setTimeout(function () { paused = false; }, 4000); }, { passive: true });

      if (!rm && slides.length > 1) {
        setInterval(function () {
          if (paused || document.hidden) return;
          atEnd() ? go(0) : go(cur() + 1);
        }, 5500);
      }
      update();
    });
  }

  function init() { reveal(); petals(); carousels(); }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();

  document.addEventListener('shopify:section:load', function () { carousels(); });
})();
